export const __container = () => ({
	display: 'flex',
	padding: '16px',
	width: '100%',
	borderRadius: '1%',
})

export const __headerContainer = () => ({
	width: '90%',
})

export const __iconContainer = () => ({
	width: '18px',
	marginLeft: 'auto',
	marginTop: '10px',
	marginRight: '10px',
})

export const __toggle = ({ isOpen }) => ({
	maxHeight: '0px',
	overflow: 'hidden',
	transition: 'max-height 0.15s ease-out',
	width: '100%',
	padding: '16px',
	opacity: 0,
	extend: [
		{
			condition: isOpen,
			style: {
				opacity: 1,
				display: 'inline-block',
				maxHeight: '100%',
				overflow: 'initial',
				transition: 'max-height 0.15s ease-in',
			},
		},
	],
})
